@if(!isEditing)
{
<div class="w-[100px] h-[40px]">
    <app-custom-button buttonText="{{ 'settings.button.edit' | transloco }}" [isDisabled]="disabled"
        backgroundColor="bg-purple" textColor="text-white" borderColor="border:bg-purple" hoverBorderColor="hover:border-purple-1200"
        hoverBackgroundColor="hover:bg-purple-1200" leadingIcon="assets/icons/settings/edit.svg"
        (click)="handleEdit()">
    </app-custom-button>
</div>}
@else
{
<div class="flex flex-wrap gap-2">
    <div class="flex items-center gap-2">
        @if(isSaving) {
            <span class="loading loading-spinner loading-sm"></span>
        }
        <div class="w-[100px] h-[40px]">
            <app-custom-button [buttonText]="isSaving ? ('shared.saving' | transloco) : ('shared.save' | transloco)" [isDisabled]="disabled"
                backgroundColor="bg-success-600" textColor="text-white" borderColor="border:bg-success-600"
                hoverBorderColor="border:bg-success-700" hoverBackgroundColor="hover:bg-success-700"
                leadingIcon="assets/icons/upload-white.svg" (click)="handleSave()">
            </app-custom-button>
        </div>
    </div>

    <div class="w-[100px] h-[40px]">
        <app-custom-button buttonText="{{ 'shared.cancel' | transloco }}" [isDisabled]="disabled"
            backgroundColor="bg-neutral-400" textColor="text-white" borderColor="border:bg-neutral-400"
            hoverBorderColor="border:bg-neutral-500" hoverBackgroundColor="hover:bg-neutral-500"
            leadingIcon="assets/icons/close-circle-white.svg" (click)="handleCancel()">
        </app-custom-button>
    </div>
</div>
}